import { htmlElem } from './globals';
import { removeEmptyElement } from './removeEmptyElement';

const resetEmptyBlogItems = () => {
    const blogElems = htmlElem.querySelectorAll('.content p, .content div, .content span');
    removeEmptyElement(blogElems);
}

export {
    resetEmptyBlogItems
}